/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 30 2024
 **/

import { PropsWithChildren, CSSProperties, HTMLAttributes } from "react";

import { ContentsWrapperStyle, IconStyle } from "./emotion";
import { useClickOutside, Button } from "../../designStuff";
import Icons from "../../assets/icons/toolbar";

export type ExpandButtonProps = {
	whiteboardMode?: WhiteboardMode;
	id?: string;
	name: string;
	className?: string;
	style?: CSSProperties;
	onClick?: (e: HtmlMouseEvent) => void;
} & HTMLAttributes<HTMLDivElement>;

export default function ExpandButton(props: PropsWithChildren<ExpandButtonProps>) {
	const { whiteboardMode, id, name, className, onClick, style, children } = props;

	const { ref, isClicked, toggleClicked } = useClickOutside();

	const handleClick = (e: HtmlMouseEvent) => {
		toggleClicked();
		if (onClick) onClick(e);
	};

	const buttonSize: CSSProperties = {
		width: whiteboardMode === "drawing" ? "clamp(20px, 4vw, 45px)" : "",
		minWidth: whiteboardMode === "drawing" ? "45px" : "",
		height: whiteboardMode === "drawing" ? "clamp(20px, 4vw, 35px)" : ""
	};

	return (
		<div ref={ref}>
			<Button
				name={name}
				id={id}
				className={className == name || isClicked ? name : ""}
				onClick={handleClick}
				style={{ ...buttonSize, ...style }}
				flexDirection={whiteboardMode === "drawing" ? "row" : "column"}
			>
				<div css={IconStyle}>{Icons["expandArrow"]}</div>
			</Button>
			<div css={ContentsWrapperStyle} className={`${whiteboardMode} ${isClicked ? "show" : ""}`}>
				{children}
			</div>
		</div>
	);
}
